module.exports = __webpack_public_path__ + "img/piccMidLiberal.409a7691.jpg";